


























































































































































import { Intervention } from "../../models/Intervention";
import PhotosViewer from "../../core/Files/PhotosViewer.vue";
import RecurrenceInterventionModal from "../../recurrence_intervention/RecurrenceInterventionModal.vue";
import { User } from "../../models/User";
import { UserApi } from "../../api/UserApi";

export default {
    name: "InterventionModalDisplay",
    components: { PhotosViewer, RecurrenceInterventionModal },
    props: {
        intervention: Intervention,
    },
    data() {
        return {
            UserApi: new UserApi(),
            EEtat: Intervention.EEtat,
            isSyndic: true,
            selectedRecurrenceInterventionId: null,
            grouppedPhotos: {},
        };
    },
    created() {
        var self = this;
        self.UserApi.getCurrentUser().then(function (user) {
            self.isSyndic = user.hasRole(User.ERole.Syndic);
        });
        self.grouppedPhotos = _.groupBy(
            this.intervention.photos,
            "intervention_secondaire_id"
        );
    },
    methods: {
        editRecurrence() {
            let self = this;
            self.selectedRecurrenceInterventionId = null;
            setTimeout(function () {
                self.selectedRecurrenceInterventionId =
                    self.intervention.recurrence_intervention_id;
            });
        },
    },
};
